<template>
  <div class="menu-wrapper">
    <div v-if="this.tabNum == 0">
      <!-- <template v-for="item in newData" v-if="!item.hidden && item.children">
        <router-link
          v-if="
            item.children.length === 1 &&
            !item.children[0].children &&
            !item.alwaysShow
          "
          :to="item.path + '/' + item.children[0].path"
          :key="item.children[0].name"
        >
          <el-menu-item :index="item.path + '/' + item.children[0].path">
            <i
              v-if="item.children[0].meta && item.children[0].meta.icon"
              :class="item.children[0].meta.icon"
            ></i>
            <i class="el-icon-s-unfold"></i>
            <span v-if="item.children[0].meta && item.children[0].meta.title">
              {{ item.children[0].meta.title }}
            </span>
          </el-menu-item>
        </router-link>

        <el-submenu v-else :index="item.name || item.path" :key="item.name">
          <template slot="title">
            <i v-if="item.meta && item.meta.icon" :class="item.meta.icon"></i>
            <i class="el-icon-s-unfold"></i>
            <span v-if="item.meta && item.meta.title">{{
              item.meta.title
            }}</span>
          </template>

          <template v-for="child in item.children" v-if="!child.hidden">
            <template v-if="child.meta.show != true">
              <sidebar-item
                :is-nest="true"
                class="nest-menu"
                v-if="child.children && child.children.length > 0"
                :routes="[child]"
                :key="child.path"
              ></sidebar-item>

              <router-link
                v-else
                :to="item.path + '/' + child.path"
                :key="child.name"
              >
                <el-menu-item :index="item.path + '/' + child.path">
                  <i
                  v-if="child.meta && child.meta.icon"
                  :class="child.meta.icon"
                ></i>

                  <span v-if="child.meta && child.meta.title">
                    {{ child.meta.title }}
                  </span>
                </el-menu-item>
              </router-link>
            </template>
          </template>
        </el-submenu>
      </template> -->
      <el-menu
        class="el-menu-vertical-demo"
        text-color="rgb(191, 203, 217)"
        background-color="#304156"
        unique-opened
      >
        <template v-for="item in leftData">
          <el-submenu
            :key="item.title"
            :index="item.title"
            v-if="item.child.length != 0"
          >
            <template slot="title">
              <!-- <i class="nav_icon child_icon"></i> -->
              <i class="el-icon-s-unfold"></i>
              <span class="text">{{ item.title }}</span>
            </template>

            <el-menu-item
              v-for="childItem in item.child"
              :key="childItem.title"
              :index="childItem.title"
              @click="getPath(childItem)"
            >
              <i class="nav_icon child_icon"></i>
              <router-link :to="childItem.href" class="text">
                {{ childItem.title }}
              </router-link>
            </el-menu-item>
          </el-submenu>

          <el-menu-item
            :key="item.title"
            :index="item.title"
            v-if="item.child.length == 0"
          >
            <i class="el-icon-s-unfold"></i>
            <!-- <i class="nav_icon child_icon"></i> -->
            <router-link :to="item.href" class="text">
              {{ item.title }}
            </router-link>
          </el-menu-item>
        </template>
      </el-menu>
      <div style="width: 20px; height: 80px"></div>
    </div>

    <div v-if="tabNum == 1">
      <el-menu
        class="el-menu-vertical-demo"
        text-color="rgb(191, 203, 217)"
        background-color="#304156"
        unique-opened
      >
        <template v-for="item in leftData">
          <el-submenu
            :key="item.title"
            :index="item.title"
            v-if="item.child.length != 0"
          >
            <template slot="title">
              <!-- <i class="nav_icon child_icon"></i> -->
              <i class="el-icon-s-unfold"></i>
              <span class="text">{{ item.title }}</span>
            </template>

            <el-menu-item
              v-for="childItem in item.child"
              :key="childItem.title"
              :index="childItem.title"
              @click="getPath(childItem)"
            >
              <i class="nav_icon child_icon"></i>
              <router-link :to="childItem.href" class="text">
                {{ childItem.title }}
              </router-link>
            </el-menu-item>
          </el-submenu>

          <el-menu-item
            :key="item.title"
            :index="item.title"
            v-if="item.child.length == 0"
          >
            <i class="el-icon-s-unfold"></i>
            <!-- <i class="nav_icon child_icon"></i> -->
            <router-link :to="item.href" class="text">
              {{ item.title }}
            </router-link>
          </el-menu-item>
        </template>
      </el-menu>
    </div>

    <div v-if="tabNum == 2">
      <el-menu
        class="el-menu-vertical-demo"
        text-color="#fff"
        background-color="#1a78f9"
        unique-opened
      >
        <template v-for="item in teacherData">
          <el-menu-item :key="item.meta.title" :index="item.meta.title">
            <router-link :to="item.path" class="text">
              <!-- <i class="nav_icon child_icon"></i> -->
              <img
                src="../../../../assets/images/cdtb_dy2.png"
                alt=""
                width="20px"
                height="20px"
              />
              {{ item.meta.title }}
            </router-link>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    routes: Array,
  },
  data() {
    return {
      leftData: [],
      newData: [],
      tabNum: "",

      teacherData: [],
    };
  },
  mounted() {
    this.tabNum = localStorage.getItem("tabNum");
    this.PowerList();
  },
  methods: {
    PowerList() {
      // console.log("pow", this.tabNum);
      if (this.tabNum == 0) {
        this.axios.get("api/Manage/User/GetOptions").then((res) => {
          console.log("列表", res.data.menuInfo[0].child);
          this.leftData = res.data.menuInfo[0].child;
          // this.getNewArr();
        });
      } else if (this.tabNum == 1) {
        this.axios.get("api/DtMage/User/GetOptions").then((res) => {
          console.log("区县", res.data.menuInfo[0].child);
          this.leftData = res.data.menuInfo[0].child;
          // this.getNewArr();
        });
      } else if (this.tabNum == 2) {
        // console.log(this.routes, "ro");
        this.routes.forEach((item) => {
          if (item.name == "mingAnswer") {
            this.teacherData.push(item.children[0]);
          }
        });
        console.log(this.teacherData, "kk");
      }
    },
    // getNewArr() {
    //   let arr = this.leftData;
    //   let rou = this.routes;
    //   rou = rou.filter(function (item, index) {
    //     if (item.path != "") {
    //       return item.children;
    //     }
    //   });
    //   for (var i = 0; i < rou.length; i++) {
    //     // console.log(rou[i].meta.title);
    //     for (var k = 0; k < arr.length; k++) {
    //       // console.log(arr[k].title);
    //       if (rou[i].meta.title == arr[k].title) {
    //         this.newData.push(rou[i]);
    //       }
    //     }
    //   }
    //   // console.log("nd", this.newData);
    // },
    getPath(list) {
      console.log("11", list);
    },
  },
};
</script>
<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue